import React, { createContext, useContext, useState } from 'react';

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState(null);

  const login = (roleFromResponse) => {
    setIsLoggedIn(true);
    setRole(roleFromResponse);
    setIsAdmin(roleFromResponse === 'admin');
  };

  const logout = () => {
    setIsLoggedIn(false);
    setRole(null);
    setIsAdmin(false);
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('role');
  };

  return (
    <AdminAuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, isAdmin, setIsAdmin, role, setRole, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
